import { ObjectLiteral } from '~/types/generics';

import { IDynamicTableTypes } from './types';

export function getDynamicTableRequest({ name, orgId }: ObjectLiteral) {
  return {
    type: IDynamicTableTypes.DYNAMIC_TABLE_REQUEST,
    payload: { name, orgId },
  };
}
export function getDynamicTableSuccess(dynamicTable: Array<string>) {
  return {
    type: IDynamicTableTypes.DYNAMIC_TABLE_SUCCESS,
    payload: { dynamicTable },
  };
}
export function getDynamicTableFailure() {
  return {
    type: IDynamicTableTypes.DYNAMIC_TABLE_FAILURE,
  };
}
